module.exports = __webpack_public_path__ + "static/media/Portrait-10186.d12ae4bd.jpg";